/** Local booking clock values; 24:00 is an end-of-day boundary only. */
function parseClockMinutes(value, { allowDayEnd = true } = {}) {
  if (typeof value !== 'string' || !/^\d{1,2}:\d{2}(?::\d{2})?$/.test(value)) return null;
  const [hours, minutes, seconds = 0] = value.split(':').map(Number);
  if (hours > 24 || minutes > 59 || seconds > 59 ||
      (hours === 24 && (!allowDayEnd || minutes !== 0 || seconds !== 0))) return null;
  return hours * 60 + minutes + seconds / 60;
}

function formatClockMinutes(value, { am = 'AM', pm = 'PM' } = {}) {
  if (!Number.isFinite(value) || value < 0 || value > 1440) return '';
  const totalSeconds = Math.round(value * 60);
  const hours = Math.floor(totalSeconds / 3600) % 24;
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const seconds = totalSeconds % 60;
  const clock = `${hours % 12 || 12}:${String(minutes).padStart(2, '0')}`;
  return `${clock}${seconds ? ':' + String(seconds).padStart(2, '0') : ''} ${hours >= 12 ? pm : am}`;
}

module.exports = { parseClockMinutes, formatClockMinutes };
